import CustomInput from '../reusable/input';
import RoloDexCard from './card_view';
import RoloDexTable from './table_view';
import { useState } from 'react';
import { Box, Button, InputAdornment } from '@mui/material';
import { Search, SortOutlined, TableChartOutlined, WidgetsOutlined } from '@mui/icons-material';

const RoloDexComponent = () => {
    const [view, setView] = useState<'table' | 'card'>('table');
    const [sortBy, setSortBy] = useState<boolean>(false);
    const [searchedValue, setSearchedValue] = useState<string>('');
    const toggleView = () => {
        setView(view === 'table' ? 'card' : 'table');
    };
    return <Box>
        {/* Toggle Button */}
        <Box display="flex" justifyContent="start" alignItems="center" gap={2} mb={2}>
            <Box>
                <CustomInput
                    value={searchedValue}
                    onChange={(e) => setSearchedValue(e.target.value)}
                    slotProps={{
                        input: {
                            startAdornment: <InputAdornment position="start">
                                <Search />
                            </InputAdornment>
                        }
                    }}
                    placeholder="Search..."
                />
            </Box>
            <Button variant="outlined" color={sortBy ? 'primary' : 'secondary'} onClick={() => setSortBy(!sortBy)} startIcon={<SortOutlined />}>
                Sort by
            </Button>
            <Button variant="outlined" color="secondary" onClick={toggleView} startIcon={view === 'card' ? <TableChartOutlined /> : <WidgetsOutlined />}>
                {view === 'table' ? 'Card View' : 'Table View'}
            </Button>
        </Box>

        {/* Conditional Rendering */}
        {view === 'table'
            ? (<RoloDexTable sort={sortBy} search={searchedValue} />)
            : (<RoloDexCard sort={sortBy} search={searchedValue} />)}
    </Box>;
};

export default RoloDexComponent;